/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import { fillerMap } from '../../../../../options';
import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  SelectController,
  RangeController,
  ChoiceBoxController,
  CustomSortController,
  ToggleSwitchController,
} from '../../../controllers/Base';

const GeneralControllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
  selectedLine = undefined,
  selectedLineMap = undefined,
  selectedColumn = undefined,
  selectedColumnMap = undefined,
}) => (
  <>
    <ControllersGroup
      title="Opções Gerais"
      id="general"
      extend={extend}
      setExtend={setExtend}
      sizeIncrease={(
        config?.SortValuesControl === 'Customizado' ? data?.index?.length : 0
      ) + (
        config?.SortColumnsControl === 'Customizado' ? data?.columns?.length : 0
      )}
    >
      {(data?.columns || []).filter((item) => {
        const fItem = typeof item === 'string' ? item : item[item.length - 1];
        return fItem !== 'Totais';
      }).length > 1 && (
        <>
          <SelectController
            label="Ordenar colunas (subcategorias)"
            handle={handle}
            kWord="SortColumnsControl"
            options={[
              { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
              { label: 'Alfabética A-Z', value: 'Alfabética A-Z', id: 'alfabetica-a-z' },
              { label: 'Alfabética Z-A', value: 'Alfabética Z-A', id: 'alfabetica-z-a' },
              { label: 'Customizado', value: 'Customizado', id: 'Customizado' },
            ]}
            configValue={config?.SortColumnsControl}
            fullWidth
          />
          {config?.SortColumnsControl === 'Customizado' && (
            <CustomSortController
              handle={handle}
              kWord="CustomSortColumnControl"
              oldOrder={data?.columns || []}
              newOrder={config?.CustomSortColumnControl?.kpiCategories || []}
              removeTotal
            />
          )}
        </>
      )}
      <SelectController
        label="Ordenar linhas (categorias)"
        handle={handle}
        kWord="SortValuesControl"
        options={[
          { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
          { label: 'Alfabética A-Z', value: 'Alfabética A-Z', id: 'alfabetica-a-z' },
          { label: 'Alfabética Z-A', value: 'Alfabética Z-A', id: 'alfabetica-z-a' },
          { label: 'Valor Crescente', value: 'Valor Crescente', id: 'valor-crescente' },
          { label: 'Valor Decrescente', value: 'Valor Decrescente', id: 'valor-decrescente' },
          { label: 'Customizado', value: 'Customizado', id: 'customizado' },
        ]}
        configValue={config?.SortValuesControl}
        fullWidth
      />
      {config?.SortValuesControl === 'Customizado' && (
        <CustomSortController
          handle={handle}
          kWord="CustomSortControlUpt"
          oldOrder={data?.index || []}
          newOrder={config?.CustomSortControl?.kpiCategories || []}
          removeTotal
        />
      )}
      {/* selectedColumn && (
        <ToggleSwitchController
          label="Remover totais"
          handle={handle}
          kWord="LineShowTotalControl"
          configValue={config?.LineShowTotalControl}
          firstOption=""
          secondOption=""
          fullWidth
        />
      ) */}
      <RangeController
        label="Margem Superior"
        handle={handle}
        kWord="MarginTop"
        configValue={config?.Margin?.top}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Inferior"
        handle={handle}
        kWord="MarginBottom"
        configValue={config?.Margin?.bottom}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Esquerda"
        handle={handle}
        kWord="MarginLeft"
        configValue={config?.Margin?.left}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Direita"
        handle={handle}
        kWord="MarginRight"
        configValue={config?.Margin?.right}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      {selectedLine?.type === 'datetime64[ns]' && selectedLineMap?.value in fillerMap && (
        <ToggleSwitchController
          label="Preencher datas faltantes na linha"
          handle={handle}
          kWord={`ExtendDateLine-${selectedLineMap?.value ?? 'none'}`}
          configValue={config?.ExtendDateLine}
          firstOption=""
          secondOption=""
          fullWidth
        />
      )}
      {selectedColumn?.type === 'datetime64[ns]' && selectedColumnMap?.value in fillerMap && (
        <ToggleSwitchController
          label="Preencher datas faltantes na coluna"
          handle={handle}
          kWord={`ExtendDateColumn-${selectedColumnMap?.value ?? 'none'}`}
          configValue={config?.ExtendDateColumn}
          firstOption=""
          secondOption=""
          fullWidth
        />
      )}
      <ChoiceBoxController
        label="Dados primários"
        handle={handle}
        kWord="DataFormat"
        configValue={config?.DataFormat}
        options={[
          { value: 'absolute', label: 'Absoluto', id: 'absolute' },
          { value: 'percentual', label: 'Percentual', id: 'percentual' },
        ]}
        fullWidth
      />
      {config?.DataFormat === 'absolute' && (
        <ChoiceBoxController
          label="Formato absoluto"
          handle={handle}
          kWord="DataAbsoluteFormat"
          configValue={config?.DataAbsoluteFormat}
          options={[
            { label: 'Número', value: 'number', id: 'number' },
            { label: 'Duração', value: 'duration', id: 'duration' },
          ]}
          fullWidth
        />
      )}
      {config?.DataFormat === 'percentual' && data?.columns?.length > 1 && (
        <ChoiceBoxController
          label="Formato percentual"
          handle={handle}
          kWord="DataPercentFormat"
          configValue={config?.DataPercentFormat}
          options={[
            { label: 'Global', value: 'global', id: 'global' },
            { label: 'Categórico', value: 'categoric', id: 'categoric' },
          ]}
          fullWidth
        />
      )}
      {(
        config?.DataFormat === 'absolute' && config?.DataAbsoluteFormat === 'duration'
      ) && (
        <>
          <hr style={{ width: '100%', color: 'lightgray', opacity: '0.2' }} />
          <ChoiceBoxController
            label="Unidade original"
            handle={handle}
            kWord="DurationUnit"
            configValue={config?.DurationUnit}
            options={[
              { label: 'Dias', value: 'days', id: 'days' },
              { label: 'Horas', value: 'hours', id: 'hours' },
              { label: 'Minutos', value: 'minutes', id: 'minutes' },
              { label: 'Segundos', value: 'seconds', id: 'seconds' },
            ]}
            fullWidth
          />
        </>
      )}
    </ControllersGroup>
  </>
);

GeneralControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedLine: PropTypes.objectOf(PropTypes.any),
  selectedLineMap: PropTypes.objectOf(PropTypes.any),
  selectedColumn: PropTypes.objectOf(PropTypes.any),
  selectedColumnMap: PropTypes.objectOf(PropTypes.any),
};

export default GeneralControllers;
